import styled from 'styled-components'
import { theme } from '../../theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  padding: 5% 5% 60px 5%;

  @media (min-width: ${theme.breakpoints.sm}px) {
    width: 70%;
    padding: 30px 5%;
  }
`

export const Title = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  display: flex;
  align-items: center;
  letter-spacing: 0.0025em;
  margin-top: 20px;
`

export const Wrapper = styled.div`
  padding-top: 15px;
`

export const FileCount = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 38px;
  max-width: 385px;
  text-align: center;
  color: ${theme.colors.orangePrimary};
`
